export const ar = {
  // Navigation
  nav: {
    home: "الرئيسية",
    ourServices: "خدماتنا",
    aboutUs: "من نحن",
    ourTeam: "فريقنا",
    contactUs: "اتصل بنا"
  },

  // Hero Section
  hero: {
    title: "توسع عالمياً بثقة",
    subtitle: "ندعمك في إنشاء عملك في الإمارات العربية المتحدة والمملكة العربية السعودية وروسيا.",
    consultationTitle: "احجز استشارة مجانية الآن",
    startNow: "ابدأ الآن",
    modalTitle: "احجز استشارة مجانية",
    countrySelect: "اختر بلدك",
    countryPlaceholder: "اختر بلداً",
    personalInfo: "المعلومات الشخصية",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    emailAddress: "عنوان البريد الإلكتروني",
    nationality: "الجنسية",
    phoneNumber: "رقم الهاتف",
    servicesLabel: "الخدمات التي تريدها",
    serviceSelect: "اختر خدمة",
    service1: "فتح الحسابات البنكية",
    service2: "التأشيرات و الخدمات القنصلية",
    service3: "حجز الفنادق",
    service4: "تذاكر الطيران",
    service5: "برمجة المواقع الإلكترونية",
    service6: "برمجة التطبيقات",
    submit: "إرسال"
  },

  // About Us Section
  aboutUs: {
    title: "من نحن",
    paragraph1: "تأسست خدمات إتقان التجارية في الإمارات العربية المتحدة لمساعدة رواد الأعمال والشركات على إنشاء شركاتهم بسهولة وسرعة. نقدم مجموعة كاملة من الخدمات بما في ذلك تأسيس الشركات في البر الرئيسي والمناطق الحرة، خدمات البرو والحكومية، الاستشارات الضريبية وضريبة القيمة المضافة، البيانات المالية، وتصديق المستندات.",
    paragraph2: "على مر السنين، أصبحنا شريكاً موثوقاً لرواد الأعمال والشركات الصغيرة والمتوسطة، حيث نقدم حلولاً قانونية ومالية وتنظيمية سلسة تدعم النمو في الإمارات العربية المتحدة وما بعدها. مهمتنا واضحة: جعل إعداد الأعمال والعمليات بسيطة وسريعة وموثوقة — حتى تتمكن من التركيز على تحقيق النجاح."
  },

  // Services Section
  services: {
    title: "خدماتنا",
    subtitle: "نقدم حلولاً تجارية شاملة",
    startingFrom: "تبدأ من",
    mainlandCompany: {
      name: "تأسيس الشركات في البر الرئيسي",
      desc: "أنشئ شركتك في البر الرئيسي بسهولة. نحن نتعامل مع جميع الخطوات القانونية حتى تتمكن من التركيز على نمو عملك.",
      price: "10,000 درهم"
    },
    freeZoneCompany: {
      name: "تأسيس الشركات في المناطق الحرة",
      desc: "أطلق عملك في المنطقة الحرة بسرعة وفعالية من حيث التكلفة. استمتع بالملكية المرنة والإعداد المبسط.",
      price: "6,000 درهم"
    },
    proServices: {
      name: "خدمات البرو والحكومية",
      desc: "من تجديد التراخيص إلى التأشيرات الذهبية، نحن ندير جميع معاملاتك الحكومية بسلاسة."
    },
    taxConsultancy: {
      name: "الاستشارات الضريبية وضريبة القيمة المضافة",
      desc: "ابق متوافقاً مع التوجيه الضريبي وضريبة القيمة المضافة الخبير. نساعدك على تقليل المخاطر وتعظيم الكفاءة."
    },
    financialStatements: {
      name: "البيانات المالية",
      desc: "تقارير مالية دقيقة تبقي عملك على المسار الصحيح. نضمن الشفافية والامتثال."
    },
    documentAttestation: {
      name: "تصديق المستندات",
      desc: "خدمات تصديق المستندات السريعة والموثوقة لجميع احتياجات عملك."
    },
    bankAccounts: {
      name: "فتح الحسابات البنكية",
      desc: "مساعدة مهنية في فتح الحسابات البنكية للأفراد والشركات في الإمارات العربية المتحدة ودولياً."
    },
    visaServices: {
      name: "التأشيرات و الخدمات القنصلية",
      desc: "خدمات شاملة للتأشيرات والهجرة تشمل التأشيرات السياحية وتأشيرات العمل وتصاريح الإقامة."
    },
    hotelBooking: {
      name: "حجز الفنادق",
      desc: "خدمات حجز الفنادق المريحة للرحلات التجارية والسياحية بأسعار تنافسية."
    },
    flightTickets: {
      name: "تذاكر الطيران",
      desc: "خدمات حجز الطيران الموثوقة مع الوصول لأفضل العروض والمسارات حول العالم."
    },
    websiteDevelopment: {
      name: "برمجة المواقع الإلكترونية",
      desc: "خدمات تطوير المواقع الإلكترونية المخصصة لإنشاء وجودك على الإنترنت ونمو عملك.",
      price: "1,500 درهم"
    },
    mobileAppDevelopment: {
      name: "برمجة التطبيقات",
      desc: "تطوير التطبيقات المحمولة المهنية لمنصات iOS و Android.",
      price: "3,500 درهم"
    }
  },

  // Our Team Section
  ourTeam: {
    title: "فريقنا",
    subtitle: "تعرف على متخصصينا الخبراء",
    members: [
      {
        name: "م.هناء",
        role: "قائدة فريق إعداد الأعمال"
      },
      {
        name: "م.علي",
        role: "قائد فريق إعداد الأعمال"
      },
      {
        name: "م.عبدالله",
        role: "قائد فريق إعداد الأعمال"
      },
      {
        name: "م.سارة",
        role: "قائدة فريق إعداد الأعمال"
      }
    ]
  },

  // Reviews Section
  reviews: {
    title: "ماذا يقول عملاؤنا",
    subtitle: "شهادات من عملاء راضين",
    testimonials: [
      {
        name: "جون دو",
        role: "الرئيس التنفيذي، شركة تيك ستارت",
        text: "جعلت إتقان إنشاء شركتي في دبي بسيطاً وسريعاً. تعامل فريقهم باحترافية، وتمكنت من بدء عملي دون توتر. تم إنجاز إعداد المنطقة الحرة في 3 أيام فقط!"
      },
      {
        name: "سامي سميث",
        role: "مدير التسويق، الحلول العالمية",
        text: "بفضل استشاراتهم الضريبية، لدي الآن ثقة كاملة أن عملي متوافق وآمن مالياً. خبرتهم وفرت علي آلاف من الغرامات المحتملة."
      },
      {
        name: "مايكل براون",
        role: "صاحب عمل، سلسلة متاجر",
        text: "فريق خدمات البرو في إتقان استثنائي. تعاملوا مع جميع معاملاتي الحكومية بسلاسة، من تجديد التراخيص إلى طلبات التأشيرات. أنصح بهم بشدة!"
      },
      {
        name: "إياد ويلسون",
        role: "مستقل، وكالة رقمية",
        text: "كمستقل، كنت أحتاج مساعدة في تصديق المستندات وفتح الحساب البنكي. جعلت إتقان كل شيء سهلاً ومقبول التكلفة. الآن يمكنني التركيز على عملائي بينما يتولون هم الأوراق."
      },
      {
        name: "ديفيد لي",
        role: "رجل أعمال، التجارة الإلكترونية",
        text: "خدماتهم في البيانات المالية ممتازة. التقارير دقيقة ومفصلة وساعدتني في الحصول على تمويل لتوسع عملي. خدمة مهنية طوال الوقت!"
      }
    ]
  },

  // Partners Section
  partners: {
    title: "شركاؤنا",
    subtitle: "موثوق بنا من قبل المنظمات الرائدة"
  },

  // Contact Us Section
  contactUs: {
    title: "اتصل بنا",
    subtitle: "تواصل معنا",
    getInTouch: "تواصل معنا",
    contactInfo: "معلومات الاتصال",
    sendMessage: "إرسال رسالة",
    name: "الاسم",
    email: "البريد الإلكتروني",
    subject: "الموضوع",
    message: "الرسالة",
    fullName: "الاسم الكامل",
    fullNamePlaceholder: "أدخل اسمك",
    emailAddress: "عنوان البريد الإلكتروني",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    phoneNumber: "رقم الهاتف",
    phonePlaceholder: "رقم الهاتف",
    activity: "النشاط",
    activityPlaceholder: "أدخل نشاطك",
    submit: "إرسال"
  },

  // Footer
  footer: {
    allRightsReserved: "جميع الحقوق محفوظة",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة",
    description: "خدمات إتقان التجارية – نجعل إعداد الأعمال سهلاً وسريعاً.",
    location: "الموقع: دبي، الإمارات العربية المتحدة",
    phone: "📞 الهاتف: +971 XXX XXX XXX",
    email: "✉️ البريد الإلكتروني: info@itqan.com",
    copyright: "© 2025 خدمات إتقان التجارية. جميع الحقوق محفوظة.",
    companyProfile: "الملف التعريفي للشركة"
  },

  // Ad Section
  ad: {
    title: "توسع عالمياً بثقة",
    startNow: "ابدأ الآن"
  },

  // Statistics Section
  statistics: {
    title: "إنجازاتنا",
    subtitle: "أرقام تتحدث عن نجاحنا",
    clients: "عملاء سعداء",
    experience: "سنوات خبرة",
    partners: "شركاء موثوقون"
  }
}; 